/* eslint-disable max-len */
import * as React from 'react';

const EyeOn = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.09607 12.0001C6.61459 15.5145 9.38674 17.1001 12 17.1001C14.6132 17.1001 17.3854 15.5145 19.9039 12.0001C17.3854 8.48566 14.6132 6.9001 12 6.9001C9.38674 6.9001 6.61459 8.48566 4.09607 12.0001ZM12 5.1001C15.5651 5.1001 18.9561 7.36344 21.7459 11.4966C21.9513 11.8008 21.9513 12.1994 21.7459 12.5036C18.9561 16.6368 15.5651 18.9001 12 18.9001C8.43489 18.9001 5.04388 16.6368 2.25401 12.5036C2.04863 12.1994 2.04863 11.8008 2.25401 11.4966C5.04388 7.36344 8.43489 5.1001 12 5.1001ZM12 9.9001C11.443 9.9001 10.9089 10.1213 10.515 10.5152C10.1212 10.909 9.89998 11.4431 9.89998 12.0001C9.89998 12.5571 10.1212 13.0912 10.515 13.485C10.9089 13.8788 11.443 14.1001 12 14.1001C12.5569 14.1001 13.0911 13.8788 13.4849 13.485C13.8787 13.0912 14.1 12.5571 14.1 12.0001C14.1 11.4431 13.8787 10.909 13.4849 10.5152C13.0911 10.1213 12.5569 9.9001 12 9.9001ZM9.24226 9.24238C9.97365 8.51099 10.9656 8.1001 12 8.1001C13.0343 8.1001 14.0263 8.51099 14.7577 9.24238C15.4891 9.97377 15.9 10.9658 15.9 12.0001C15.9 13.0344 15.4891 14.0264 14.7577 14.7578C14.0263 15.4892 13.0343 15.9001 12 15.9001C10.9656 15.9001 9.97365 15.4892 9.24226 14.7578C8.51087 14.0264 8.09998 13.0344 8.09998 12.0001C8.09998 10.9658 8.51087 9.97377 9.24226 9.24238Z"
      fill="#5C5C5C"
    />
  </svg>
);
export default EyeOn;
